import React from "react"
import "./BetaWaitlist.scss"
import { WaitlistModal } from "./waitlistModal"
import gql from "graphql-tag"
import { Mutation } from "react-apollo"

const VIEWER_QUERY = gql`
  query ViewerQuery {
    viewer {
      id
      joinedBetaWaitlist
    }
  }
`

const ADD_USER_TO_BETA_WAITLIST = gql`
  mutation BetaWaitlistRequest {
    betaWaitlistRequest {
      message
      success
    }
  }
`

const BetaWaitlist = (props) => {
  const { type, viewer } = props
  const [modalOpen, setModalOpen] = React.useState(false)

  return (
    <>
      {type === "banner" && (
        <div className="banner" data-cy="beta-waitlist-cta">
          <div className="top-image">
            <img src="/static/images/beta-waitlist.png" />
          </div>
          <div className="skewed-content">
            <p>
              We are thrilled to announce that our new platform beta will be
              launching soon!
            </p>
            <button
              onClick={() => {
                if (!modalOpen) {
                  setModalOpen(true)
                }
              }}
              data-cy="beta-waitlist-banner-button"
            >
              <img src="/static/images/beta-button.png" />
            </button>
          </div>
          <div className="bottom-logo">
            <img
              className="logo"
              src="/static/images/ETR-color-ltrs-logo.png"
            />
          </div>
        </div>
      )}

      {type === "button" && (
        <button
          onClick={() => {
            if (!modalOpen) {
              setModalOpen(true)
            }
          }}
          data-cy="beta-waitlist-top-button"
          className="beta-waitlist-top-button"
        >
          <img src="/static/images/waitlist-button.png" />
        </button>
      )}
      <Mutation mutation={ADD_USER_TO_BETA_WAITLIST}>
        {(mutate, { client }) => {
          const refetchViewer = () =>
            client.query({
              query: VIEWER_QUERY,
              fetchPolicy: "network-only",
            })

          return (
            <WaitlistModal
              mutate={mutate}
              isOpen={modalOpen}
              onClose={setModalOpen}
              joinedWaitlist={viewer.joinedWaitlist}
              refetchQueries={refetchViewer}
            />
          )
        }}
      </Mutation>
    </>
  )
}
export default BetaWaitlist
